import React from "react";

const ReportsIcon = ({
  width = 10,
  height = 9,
  color = "none",
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 10 9"
    fill={color}
  >
    <path
      d="M5 0.5C2.79086 0.5 1 2.29086 1 4.5C1 6.70914 2.79086 8.5 5 8.5C7.20914 8.5 9 6.70914 9 4.5M5 0.5C7.20914 0.5 9 2.29086 9 4.5M5 0.5V4.5M9 4.5H5M7.66667 7.38889L5 4.5"
      stroke="currentColor"
      stroke-width="0.888889"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default ReportsIcon;
